import { render, staticRenderFns } from "./NewTaskModal.vue?vue&type=template&id=f7baae36&scoped=true&"
import script from "./NewTaskModal.vue?vue&type=script&lang=ts&"
export * from "./NewTaskModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7baae36",
  null
  
)

export default component.exports